import { RootState } from 'editor/src/store/index';

import getSessionImages from './getSessionImages';

const getGalleryImagesUploadedSum = (state: RootState) =>
  getSessionImages(state).reduce((acc, image) => acc + (image.bytesUploaded || 0), 0);

export default getGalleryImagesUploadedSum;
